import React, { useContext } from 'react';

import Box from '@mui/material/Box';

// load navigation contents from JSON file
import footerContentItemsProduction from '@config/data/footerContentItems.json';
import footerContentItemsStaging from '@config/data/footerContentItems.staging.json';
import footerContentItemsDevelopment from '@config/data/footerContentItems.development.json';

// Section for import custom components --------------------------------------------------------------------------------
import CommonUtility from '@utils/Common';
import { AppConfigContext } from '@providers/AppConfigProvider';

interface MenuContentProps {
  color: 'black' | 'white';
  excludeKeys?: string[]; // 除外する項目を親要素で指定可能にしています
}

export default function MenuContent({ color = 'black', excludeKeys = [] }: MenuContentProps) {
  const { appEnv } = useContext(AppConfigContext);

  const footerContentItems = CommonUtility.getEnvBasedValue(
    {
      production: footerContentItemsProduction,
      staging: footerContentItemsStaging,
      development: footerContentItemsDevelopment,
    },
    appEnv,
  );

  const textColorClass = color === 'white' ? 'text-white' : 'text-black';

  return (
    <Box className={`flex flex-wrap  gap-y-10 justify-between ${textColorClass}`}>
      {footerContentItems
        .filter((item) => !excludeKeys.includes(item.key))
        .map((item, index) => {
          const spanClass = index === 0 || index === 3 || index === 6 ? 'min-w-[28%]' : 'min-w-[36%]';
          return (
            <Box key={item.key} className={`${spanClass}`}>
              <h2 className="text-lg font-bold tracking-[0.16em]">
                <a href={item.href} rel="noopener noreferrer" className="rf-hover-text hover:no-underline">
                  {item.label}
                </a>
              </h2>
              {item.children &&
                item.children.map((child) => (
                  <Box key={child.key} className="flex items-center mt-5 ml-7">
                    <h3 className="text-sm">
                      <a href={child.href} rel="noopener noreferrer" className="rf-hover-text hover:no-underline">
                        {child.label}
                      </a>
                    </h3>
                  </Box>
                ))}
            </Box>
          );
        })}
    </Box>
  );
}
